import React, {Component} from 'react';
import {Scrollbars} from "react-custom-scrollbars";
import {checkWordReplace} from "../htmlFormat";
import {formatTime, uuid} from "../../../../../../../utils";
import {Modal} from "antd";

class WechatView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            title: '',
            logo: '',
            positionName: '',
            content: '',
            updateDate: '',
            visible: false
        }
    }

    componentDidMount() {
    }

    /**
     * 给数据打敏感词标记
     */
    setCheckWord = ({title = "", content = ""}) => {
        if (this.currentItem.positionSecurityList?.length) {
            this.currentItem.positionSecurityList.forEach(item => {
                let itemWord = item.word;//错误词
                let itemCorrectWord = item.correct;//正确词
                let currWord = '“' + itemWord + '”建议修改为：“' + itemCorrectWord + '”';
                let replaceHtml = '<span class="itemWord_newMedia currentWord_newMedia" check="' + currWord + '">' + itemWord + '</span>';
                content = checkWordReplace(content, item?.word, replaceHtml);
                title = checkWordReplace(title, item?.word, replaceHtml);
            })
        }
        return {title, content}
    };

    currentItem = {}

    show = (currentItem) => {
        this.currentItem = currentItem;
        let title = this.setCheckWord({
            title: currentItem.title,
            content: currentItem.cmSiteContent
        }).title;
        let content = this.setCheckWord({
            title: currentItem.title,
            content: currentItem.cmSiteContent
        }).content;
        this.setState({
            title,
            content,
            positionName: currentItem.positionName,
            logo: currentItem.logo,
            updateDate: window.formatDate(currentItem.publishTime),
            ...currentItem,
            visible: true
        })
    };

    onOnce = () => {
        const {hoverText} = this.props;
        let flag = false;
        return function () {
            if(!flag) {
                hoverText && hoverText()
                flag = true;
            }
        }
    }

    hoverText = this.onOnce()

    render() {
        const {title = "", content = "", positionName, updateDate, logo} = this.state;
        return (
            <Modal key={uuid()} title={"查看内容"} visible={this.state.visible} bodyStyle={{height: 650}}
                   width={700}
                   okButtonProps={{
                       style: {display: "none"}
                   }}
                   onCancel={() => {
                       this.hoverText = this.onOnce()
                       this.setState({visible: false})
                   }} cancelText={"关闭"}>
                <Scrollbars>
                    <div style={{padding: "0 15px"}} className={"preview_content"} onMouseEnter={this.hoverText}>
                        <div style={{display: "flex", width: "100%"}}>
                            <div style={{fontWeight: "bold", fontSize: 18, width: "85%"}}
                                 dangerouslySetInnerHTML={{__html: title}}></div>
                            <div style={{width: "15%"}}><span style={{color: "#0050B3", cursor: "pointer"}} onClick={() => {
                                window.open(this.state.url)
                            }}>原文链接</span></div>
                        </div>
                        <div style={{display: "flex", alignItems: "center"}}>
                            <div style={{marginRight: "5px"}}><img style={{width: 15, height: 15, objectFit: "cover"}} src={logo}/></div>
                            <div style={{marginRight: "5px"}}>{positionName}</div>
                            <div>{formatTime(updateDate)}</div>
                        </div>
                        <div style={{paddingTop: "15px"}} dangerouslySetInnerHTML={{__html: content}}></div>
                    </div>
                </Scrollbars>
            </Modal>
        );
    }
}

export default WechatView;